import moment from 'moment'

export default {
    "entityName": "siterequest",
    upsert: 'full',
    // "title": "Site request",
    "pagination": {
        "itemsPerPage": 10,
        "page": 1,
        "sortBy": "request_date",
        "descending": true
    },
    "fields": [
        {
            value: 'request_date',
            text: 'Date',
            table: true,
            render: item => moment(item.request_date).format('YYYY-MM-DD'),
        },
        {
            "value": "protocol_id",
            "text": "Protocol",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                filter: true
            },
            "title": "name",
            validators: ['required']
        },
        {
            "value": "status",
            "text": "Status",
            "type": "list",
            "table": {
                "sortable": true,
                "filter": true
            },
            "list": [
                "NEW", "REQUESTED", "CONFIRMED", "SENT", "RECEIVED", "CANCELED", "LOST", "IMPORTED"
            ],
            visible: false
        },
        {
            "value": "n_patients",
            "text": "N. patients",
            "type": "number",
            "validators": [
                "required",
                "number"
            ]
        },
        {
            "value": "request_arrival_date",
            "text": "Request arrival date",
            "type": "datetime",
        },
        {
            "value": "urgent",
            "text": "Urgent",
            "type": "check",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // }
        },
        {
            full: true,
            "value": "urgency_reason",
            "text": "Urgency reason",
            "type": "textarea",
            readonly: item => !item.urgent
        },
        {
            value: 'response_drugs.name, request_drugs.name',
            text: 'Drugs',
            filter: (item, search) => [{ 'response_drugs.name': `%${search}%` }, { 'request_drugs.name': `%${search}%`}],
            id: 'id',
            title: 'name',
            subtitle: item => `${item.dose}${item.measure_unit}`,
            type: 'autocomplete',
            table: {
                sortable: true,
                filter: true,
            },
            render: item => item.status === 'RECEIVED' || item.status === 'IMPORTED' ?
                item.response_drugs && item.response_drugs.reduce((drugs, drug) => drugs += `${drug.name}(${drug.packaging !== 'Labels' ? drug.dose + drug.measure_unit : 'labels ' + JSON.parse(drug._JSON_labels || '[]').join(',') }) ` , '') :
                item.request_drugs && item.request_drugs.reduce((drugs, drug) => drugs += `${drug.name}(${drug.packaging !== 'Labels' ? drug.dose + drug.measure_unit : 'labels ' + JSON.parse(drug._JSON_labels || '[]').join(',') }) ` , ''),
            visible: false
        }

    ],
    "actions": [
        "upsert"
    ]
}